import gql from "../gql";
import EarnedAward from "./EarnedAward";
export default gql `
  fragment EarnedAwards on EarnedAwardConnection {
    __typename
    edges {
      __typename
      node {
        ...EarnedAward
      }
    }
    totalCount
    pageInfo {
      __typename
      startCursor
      endCursor
      hasNextPage
    }
  }
  ${EarnedAward}
`;
